/**
 * @props isHighlighted: To show the green border on the card. It will also show the checkbox icon on the top right side (boolean)
 * @props children: (node)
 * @props fullWidth: Allows card to aquire full width of it's parent. (boolean)
 * @props alignItems: To align the items on the card (string: all the available properties of align-items)
 * @props justifyContent: To align the items on the card (string: all the available properties of justify-content)
 */

import React from "react";
import { Card } from "reactstrap";
import styles from "./BasicCard.styles";
import Icons from "../../icons/Icons";
import { VEC_ICON_NAME } from "../../icons/constants";
import Button from "../../button/Button";
import { BUTTON_TYPE } from "../../button/constants";

export default function BasicCard({
  isHighlighted = false,
  children,
  customStyles = {},
  fullWidth = false,
  alignItems = "flex-start",
  justifyContent = "flex-start",
  circularCheckboxStyles = {},
  isHighlightedIcon = VEC_ICON_NAME.CIRCULAR_CHECKBOX,
  isRemoveable = false,
  onRemoveCB = () => {}
}) {

  const greenBorder = isHighlighted ? styles.greenBorder : {};

  return (
    <>
      <Card
        style={{
          ...styles.cardStyle,
          ...greenBorder,
          alignItems,
          justifyContent,
          ...customStyles,
        }}
        className={fullWidth ? "w-100" : ""}
      >
        {children}

        {isHighlighted && isHighlightedIcon && (
          <div style={{ ...styles.checkBoxIcon, ...circularCheckboxStyles }}>
            <Icons
              familyName="vec"
              iconName={isHighlightedIcon}
            />
          </div>
        )}
        {isRemoveable && <div style={styles.cancelIcon}>
          <Button type={BUTTON_TYPE.LIGHT_WITH_NO_BORDER} onClickCb={onRemoveCB}>X</Button>
          </div>}
      </Card>
    </>
  );
}
